"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toVideoMetadataArray = exports.toStory = exports.toWebPlayerStory = exports.toWebPlayerStoryType = void 0;
const users_1 = require("@snapchat/content-platform-www/generated-src/snapchat/web/stories/users");
const assert_1 = __importDefault(require("assert"));
const stories_1 = require("./stories");
const web_story_web_player_1 = require("@snapchat/web-story-web-player");
const typeConversions_1 = require("./typeConversions");
function toSnapUrls(snapUrls) {
    (0, assert_1.default)(snapUrls);
    return {
        mediaUrl: snapUrls.mediaUrl,
        mediaPreviewUrl: snapUrls.mediaPreviewUrl?.value,
        overlayUrl: snapUrls.overlayUrl?.value,
        attachmentUrl: snapUrls.attachmentUrl?.value,
    };
}
/**
 *
 */
function toWebPlayerStoryType(playerStoryTypeString) {
    if (playerStoryTypeString === "TYPE_DYNAMIC")
        return web_story_web_player_1.WWWStoryType.DYNAMIC;
    if (playerStoryTypeString === "TYPE_PUBLIC_USER_STORY")
        return web_story_web_player_1.WWWStoryType.PUBLIC_USER;
    if (playerStoryTypeString === "TYPE_MAPS")
        return web_story_web_player_1.WWWStoryType.MAPS;
    if (playerStoryTypeString === "PUBLISHER")
        return web_story_web_player_1.WWWStoryType.PUBLISHER;
    if (playerStoryTypeString === "TYPE_SHARED_OUR_STORY_SNAP")
        return web_story_web_player_1.WWWStoryType.MAPS; // this maps to OUR in the embedded player
    if (playerStoryTypeString === "TYPE_COMMUNITY")
        return web_story_web_player_1.WWWStoryType.SPOTLIGHT;
    return web_story_web_player_1.WWWStoryType.PUBLIC_USER;
}
exports.toWebPlayerStoryType = toWebPlayerStoryType;
function toStoryType(playerStoryTypeString) {
    if (playerStoryTypeString === "TYPE_DYNAMIC")
        return stories_1.StoryType.DYNAMIC;
    if (playerStoryTypeString === "TYPE_PUBLIC_USER_STORY")
        return stories_1.StoryType.PUBLIC_USER;
    if (playerStoryTypeString === "TYPE_MAPS")
        return stories_1.StoryType.MAPS;
    if (playerStoryTypeString === "PUBLISHER")
        return stories_1.StoryType.PUBLISHER;
    if (playerStoryTypeString === "TYPE_SHARED_OUR_STORY_SNAP")
        return stories_1.StoryType.MAPS; // this maps to OUR in the embedded player
    if (playerStoryTypeString === "TYPE_COMMUNITY")
        return stories_1.StoryType.SPOTLIGHT;
    return stories_1.StoryType.PUBLIC_USER;
}
function toWebPlayerSnapList(snaps) {
    return snaps.map((snap) => ({
        index: snap.snapIndex,
        // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain,@typescript-eslint/no-non-null-assertion
        id: snap.snapId?.value,
        snapMediaType: (0, typeConversions_1.toSnapMediaTypeForWebPlayer)(users_1.PlayerSnapMediaType[snap.snapMediaType]),
        snapUrls: toSnapUrls(snap.snapUrls),
        isSponsored: snap.isSponsored?.value,
        timestampInSec: snap.timestampInSec && parseInt(snap.timestampInSec.value),
        snapTitle: snap.snapTitle?.value,
        snapSubtitles: snap.snapSubtitles?.value,
        lat: snap.lat?.value,
        lng: snap.lng?.value,
        hasAttachment: snap.hasAttachment?.value,
        intervalStartTimeMs: snap.intervalStartTimeMs && parseInt(snap.intervalStartTimeMs.value),
    }));
}
function toSnapList(playerSnaps) {
    return playerSnaps.map((playerSnap) => {
        const { snapUrls, snapMediaType } = playerSnap;
        const snap = {
            snapUrls: toSnapUrls(snapUrls),
            snapMediaType: (0, typeConversions_1.toSnapMediaType)(users_1.PlayerSnapMediaType[snapMediaType]),
            snapIndex: playerSnap.snapIndex,
            snapId: playerSnap.snapId?.value,
            isSponsored: playerSnap.isSponsored?.value,
            timestampInSec: playerSnap.timestampInSec && parseInt(playerSnap.timestampInSec.value),
            snapTitle: playerSnap.snapTitle?.value,
            snapSubtitles: playerSnap.snapSubtitles?.value,
            lat: playerSnap.lat?.value,
            lng: playerSnap.lng?.value,
            intervalStartTimeMs: playerSnap.intervalStartTimeMs && parseInt(playerSnap.intervalStartTimeMs.value),
        };
        return snap;
    });
}
/**
 *
 */
function toWebPlayerStory(story) {
    return {
        type: toWebPlayerStoryType(users_1.StoryType[story.storyType]),
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        snaps: toWebPlayerSnapList(story.snapList || []),
        id: story.storyId?.value,
        title: story.storyTitle?.value,
        thumbnailUrl: story.thumbnailUrl?.value,
        storySubtitle: story.storySubtitle?.value,
        storyShareId: story.storyShareId?.value,
        canonicalUrlSuffix: story.canonicalUrlSuffix?.value,
        emoji: story.emoji?.value,
        videoTrackUrl: story.videoTrackUrl?.value,
    };
}
exports.toWebPlayerStory = toWebPlayerStory;
/**
 *
 */
function toStory(playerStory) {
    const { storyType, snapList } = playerStory;
    return {
        storyType: toStoryType(users_1.StoryType[storyType]),
        snapList: toSnapList(snapList),
        storyId: playerStory.storyId?.value,
        storyTitle: playerStory.storyTitle?.value,
        thumbnailUrl: playerStory.thumbnailUrl?.value,
        storySubtitle: playerStory.storySubtitle?.value,
        storyShareId: playerStory.storyShareId?.value,
        canonicalUrlSuffix: playerStory.canonicalUrlSuffix?.value,
        emoji: playerStory.emoji?.value,
        videoTrackUrl: playerStory.videoTrackUrl?.value,
    };
}
exports.toStory = toStory;
/**
 *
 */
function toVideoMetadataArray(spotlightStoryMetadata) {
    const numOfVideo = 10;
    const videoMetadata = [];
    if (spotlightStoryMetadata === undefined || spotlightStoryMetadata.length === 0) {
        return videoMetadata;
    }
    for (const spotlightStory of spotlightStoryMetadata) {
        if (videoMetadata.length >= numOfVideo) {
            return videoMetadata;
        }
        if (spotlightStory.videoMetadata !== undefined) {
            videoMetadata.push(spotlightStory.videoMetadata);
        }
    }
    return videoMetadata;
}
exports.toVideoMetadataArray = toVideoMetadataArray;
//# sourceMappingURL=conversions.js.map